import React from 'react';
import { Mail, Phone, Linkedin, ArrowUp } from 'lucide-react';
import { contactInfo, consultants } from '../data/mock';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-bg-card border-t border-border-medium">
      <div className="container">
        {/* Main Footer Content */}
        <div className="py-16">
          <div className="grid lg:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="lg:col-span-2">
              <div className="mb-6">
                <img 
                  src="https://customer-assets.emergentagent.com/job_b643e2b7-1d18-42a1-b855-27b1c43cee32/artifacts/tzoga71i_logoManch.svg"
                  alt="Manch Studios" 
                  className="h-12 w-auto filter invert mb-4"
                />
              </div>
              <p className="body-medium max-w-md mb-6">
                Consultoria especializada em design de produtos digitais e industriais. 
                Transformamos ideias em produtos que elevam e funcionam.
              </p>
              <div className="flex items-center gap-4">
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="w-10 h-10 bg-brand-primary/10 rounded-full flex items-center justify-center border border-brand-primary/20 hover:bg-brand-primary hover:text-text-inverse transition-colors"
                >
                  <Mail size={16} />
                </a>
                <a
                  href={`tel:${contactInfo.phone}`}
                  className="w-10 h-10 bg-brand-primary/10 rounded-full flex items-center justify-center border border-brand-primary/20 hover:bg-brand-primary hover:text-text-inverse transition-colors"
                >
                  <Phone size={16} />
                </a>
                {consultants.map((consultant) => (
                  <a
                    key={consultant.id}
                    href={consultant.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 bg-brand-primary/10 rounded-full flex items-center justify-center border border-brand-primary/20 hover:bg-brand-primary hover:text-text-inverse transition-colors"
                  >
                    <Linkedin size={16} />
                  </a>
                ))}
              </div>
            </div>

            {/* Services */}
            <div>
              <h3 className="heading-3 text-lg mb-6 text-white">Serviços</h3>
              <ul className="space-y-3">
                <li><a href="#services" className="text-text-secondary hover:text-brand-primary transition-colors">UX/UI Design</a></li>
                <li><a href="#services" className="text-text-secondary hover:text-brand-primary transition-colors">Design Industrial</a></li>
                <li><a href="#services" className="text-text-secondary hover:text-brand-primary transition-colors">Prototipagem</a></li>
                <li><a href="#services" className="text-text-secondary hover:text-brand-primary transition-colors">Consultoria</a></li>
                <li><a href="#services" className="text-text-secondary hover:text-brand-primary transition-colors">Realidade Virtual</a></li>
                <li><a href="#services" className="text-text-secondary hover:text-brand-primary transition-colors">Treinamentos</a></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="heading-3 text-lg mb-6 text-white">Contato</h3>
              <div className="space-y-4">
                <div>
                  <p className="text-text-secondary mb-1">Email</p>
                  <a 
                    href={`mailto:${contactInfo.email}`}
                    className="text-brand-primary hover:text-brand-hover transition-colors"
                  >
                    {contactInfo.email}
                  </a>
                </div>
                <div>
                  <p className="text-text-secondary mb-1">Telefone</p>
                  <a 
                    href={`tel:${contactInfo.phone}`}
                    className="text-brand-primary hover:text-brand-hover transition-colors"
                  >
                    {contactInfo.phone}
                  </a>
                </div>
                <div>
                  <p className="text-text-secondary mb-1">Atendimento</p>
                  <p className="text-white">Online em todo o Brasil</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="py-6 border-t border-border-light">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-text-secondary text-sm">
              © {currentYear} Manch Studios. Todos os direitos reservados.
            </p>
            
            <div className="flex items-center gap-6">
              <button 
                onClick={scrollToTop}
                className="w-10 h-10 bg-brand-primary/10 rounded-full flex items-center justify-center border border-brand-primary/20 hover:bg-brand-primary hover:text-text-inverse transition-colors group"
              >
                <ArrowUp size={16} className="group-hover:-translate-y-1 transition-transform" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;